<template>
    <a :href="($scope.PROMO || {}).banner_top_link" v-if="countdownDeadline" class="text-no-decoration">
        <div class="text-center bg-info-3 text-yanone text-white cursor-pointer">
            <div class="d-inline-flex flex-align-center">
                <span class="flex-child-fixed mr">A promoção encerra em:</span>
                <Countdown class="flex-child-fixed" :deadline="countdownDeadline"/>
            </div>
        </div>
    </a>
</template>

<script>
    import Countdown from "../common/Countdown";
    import {timeHandler} from "../../../common/common";

    export default {
        name: "HomeCountdown",

        el: '#vue-home-countdown',

        components: {Countdown},

        data() {
            return {
                countdownDeadline: null
            }
        },

        created() {
            this.countdownDeadline = this.getCountdownDeadline();
        },

        methods: {
            getCountdownDeadline() {
                if (this.$scope.PROMO && this.$scope.PROMO.contador === '1' && this.$scope.IS_REGULAR_CUSTOMER) {
                    const promoStartDate = timeHandler(this.$scope.PROMO.data_inicio).toDate();
                    const promoEndDate = timeHandler(this.$scope.PROMO.data_fim).toDate();

                    if (promoStartDate && promoEndDate) {
                        const now = new Date();
                        const diff = promoEndDate.getTime() - now.getTime();
                        if (promoStartDate < now && promoEndDate > now && diff < 2 * 24 * 3600 * 1000) {
                            return promoEndDate;
                        }
                    }
                }

                return null;
            },
        }
    }
</script>